import { network } from './network';

export async function loginWithGoogle(opts) {
	const res = await network({
		url: '/api/v1/login/web/google',
		method: 'post',
		headers: {
			'App-Id': opts.appid
		},
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}